export const HeaderComponent = ({
  staticFirstSlide,
  title,
  description,
}: {
  staticFirstSlide: boolean;
  title: string;
  description: string;
}) => {
  if (staticFirstSlide) {
    return (
      <div className='pk-d--flex pk-flex--column pk-text--text-04' slot='static'>
        <h2 className='pk-font--base-bold pk-font-size-md--xl2 pk-font-size--l pk-w--100'>{title}</h2>
        {!!description && (
          <summary className='pk-font--base-regular pk-font-size--s pk-font-size-md--m pk-m--0 pk-pt--s pk-line-height--md pk-text--text-02'>
            {description}
          </summary>
        )}
      </div>
    );
  }
  return (
    <div slot='headline'>
      <h2 className='pk-font--base-bold pk-font-size-md--xl2 pk-font-size--l'>{title}</h2>
      {!!description && (
        <summary className='pk-font--base-regular pk-font-size--s pk-font-size-md--m pk-m--0 pk-pt--xs pk-text--text-02'>
          {description}
        </summary>
      )}
    </div>
  );
};
